module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DialogBox', {
    attrs: {
      "settings": _vm.settings,
      "disabled": !_vm.isFormValid
    },
    on: {
      "save": _vm.save,
      "show": _vm.showDialog,
      "hide": _vm.hideDialog
    }
  }, [_c('div', {
    staticClass: "pa-4",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Type of Filter",
      "items": ['Visible']
    },
    model: {
      value: (_vm.filter.type),
      callback: function($$v) {
        _vm.$set(_vm.filter, "type", $$v)
      },
      expression: "filter.type"
    }
  }), _vm._v(" "), _c('v-combobox', {
    attrs: {
      "label": "Element Name",
      "items": _vm.masterNames
    },
    model: {
      value: (_vm.filter.name),
      callback: function($$v) {
        _vm.$set(_vm.filter, "name", $$v)
      },
      expression: "filter.name"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "label": "Operator",
      "items": _vm.operators.map(function (o) { return o.name; })
    },
    model: {
      value: (_vm.filter.operator),
      callback: function($$v) {
        _vm.$set(_vm.filter, "operator", $$v)
      },
      expression: "filter.operator"
    }
  }), _vm._v(" "), _c('v-combobox', {
    attrs: {
      "multiple": "",
      "chips": "",
      "label": "Is one of the following",
      "items": _vm.masterChoices
    },
    model: {
      value: (_vm.filter.values),
      callback: function($$v) {
        _vm.$set(_vm.filter, "values", $$v)
      },
      expression: "filter.values"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d970db8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/FilterEditor.vue
// module id = 2571
// module chunks = 1